<template>
  <v-card flat>
    <v-toolbar color="grey lighten-4" light tile flat>
      <v-toolbar-title centered class="headline font-weight-bold">
        Agents
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="mdi-account-search-outline"
        label="Search"
        outlined
        rounded
        solo
        single-line
        hide-details
      ></v-text-field>
    </v-toolbar>

    <v-data-table :items="company.agents" :headers="headers" :search="search">
      <template slot="item.activity" slot-scope="{ item }">
        <v-switch
          inset
          :input-value="!!item.is_active"
          @change="toggleAgentActivity(item)"
          color="primary"
        ></v-switch>
      </template>
      <table-column label="Network">
        <AgentNetwork slot-scope="agent" :agent="agent" :dataNetworks="company.networks" />
      </table-column>
    </v-data-table>
  </v-card>
</template>
<script>
/* eslint-disable */
import { updateArrayEntry } from "@/store/utils";
import AgentNetwork from "./network";
export default {
  props: ["company"],
  data() {
    return {
      search: "",
      headers: this.pairTableLabelWithValue({
        "First Name": "user.first_name",
        "Last Name": "user.last_name",
        "Phone Number": "user.full_phone_number",
        Country: "user.country",
        Activity: "activity",
      }),
    };
  },
  components: { AgentNetwork },
  methods: {
    toggleAgentActivity(agent) {
      // this.$http
      //   .put(`/api/v1/companies/${this.company.id}/agents/${agent.client.id}`)
      //   .then(response => {
      //     const newAgent = Object.assign({}, agent, response);
      //     console.log(newAgent);
      //     this.$emit("update:company", {
      //       ...this.company,
      //       agents: updateArrayEntry(this.company.agents, newAgent, agent.id),
      //     });
      //     Window.Notify.success("Operation successful");
      //   });
    },
  },
};
</script>
